import { Button } from "components/ButtonNew";
import { useTranslation } from "react-i18next";
import { customApiCall } from "utils/axios";

import { transientJobUrls } from "../api/urls";
import { useJobLogFileUrl } from "../hooks/useJobLogFileUrl";
import { downloadFromUrl } from "../lib/downloadFromUrl";

type TransientJobLogDownloadButtonProps = {
  configId?: number;
};

export const TransientJobLogDownloadButton = ({ configId }: TransientJobLogDownloadButtonProps) => {
  const { t } = useTranslation();
  const { file } = useJobLogFileUrl(configId);
  const downloadUrl = file?.path ? transientJobUrls.fileDownload(file.path) : file?.url;
  if (!file || !downloadUrl) return null;

  return (
    <Button
      onClick={() =>
        file.path
          ? customApiCall.download({
              errorMessage: String(t("general.downloadFileProblem")),
              fileName: file.name,
              url: downloadUrl,
            })
          : downloadFromUrl(downloadUrl, file.name)
      }
      startIconName="Download"
      variant="secondary"
    >
      {t("Execution.transient.jobDetails.downloadLog")}
    </Button>
  );
};
